import {
  taskTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/tasks/templates'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useDiscardTaskTemplateVersion = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['discardTaskTemplateVersion']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...taskTemplateKeys.discardTaskTemplateVersion,
    ...options,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: taskTemplateKeys.getTaskTemplateVersions({
          templateId: variables.templateId,
        }).queryKey,
      })
    },
  })
}
